export default function CTASection() {
  return (
    <section className="py-40 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="relative h-[700px] rounded-[40px] overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/8ba1957971136879efee1369e1bd2f0e.jpg"
            alt="Taller artístico"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
          
          <div className="absolute inset-0 flex flex-col justify-between p-24">
            <div className="mt-20">
              <h2 className="text-8xl font-bold text-white lowercase" style={{ fontFamily: 'Inter, sans-serif' }}>
                transforma tus espacios
              </h2>
            </div>
            
            <div className="flex items-end justify-between">
              <a
                href="#contacto"
                className="group bg-white text-gray-900 px-10 py-5 rounded-full flex items-center gap-4 hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="text-lg font-medium">Solicitar cotización</span>
                <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white text-xl"></i>
                </div>
              </a>
              
              <div className="text-right">
                <p className="text-white text-2xl font-light">Enmarcación personalizada</p>
                <p className="text-white text-2xl font-light">para cada momento especial</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
